module.exports = __webpack_public_path__ + "img/logoGreen.f1f8dde9.png";